const token = localStorage.getItem('accessToken');
export const configToken = {
  headers: {
    Accept: 'application/json',
    Authorization: `Bearer ${token}`,
  },
};